export enum SMS_TYPE {
    SMS = 'sms',
    MMS = 'mms',
    RCS = 'rcs',
    WHATSAPP = 'whatsapp'
}

export enum SMS_DIRECTION {
    INBOUND = 'inbound',
    OUTBOUND = 'outbound'
}

export enum SMS_CARRIER {
    ATT = 'att',
    TMOBILE = 'tmobile',
    VERIZON = 'verizon',
    USCELLULAR = 'uscellular',
    CSPIRE = 'cspire',
    CLEARSKY = 'clearsky',
    SPRINT = 'sprint',
    TELUS = 'telus',
    BELLVIRGIN = 'bellvirgin',
    VIDEOTRON = 'videotron',
    EASTLINK = 'eastlink',
    FIDO = 'fido',
    FREEDOM = 'freedom',
    ROGERS = 'rogers',
    SASKTEL = 'sasktel',
    CLARO = 'claro'
}

export enum CONTENT_TYPE {
    JPEG = 'image/jpeg',
    PNG = 'image/png',
    GIF = 'image/gif',
    WEBP = 'image/webp',
    AVIF = 'image/avif',
    XVCF = 'text/x-vcard',
    VCF = 'text/vcard',
    CSV = 'text/csv'
}

export const IMAGE_CONTENT_TYPE = new Set([
    CONTENT_TYPE.JPEG,
    CONTENT_TYPE.PNG,
    CONTENT_TYPE.GIF,
    CONTENT_TYPE.WEBP,
    CONTENT_TYPE.AVIF
] as const);

export enum MESSAGE_STATUS {
    QUEUED = 'queued',
    PENDING = 'pending',
    SENT = 'sent',
    DELIVERED = 'delivered',
    ERROR = 'error',
    AWAITING_APPROVAL = 'awaiting_approval'
}

export enum MESSAGE_TYPE {
    BASIC = 'basic',
    MANUAL = 'manual',

    ONBOARD = 'onboard',
    ONE_TIME_CODE = 'one_time_code',
    OPT_IN_FLOW = 'opt_in_flow',

    WELCOME = 'welcome',
    ONETEXT_WELCOME = 'onetext_welcome',

    CONTACT_CARD = 'contact_card',

    PRODUCT_CHOICE = 'product_choice',
    PRODUCT_CHOICE_MORE = 'product_choice_more',
    PRODUCT_OFFER = 'product_offer',

    PURCHASE_OFFER = 'purchase_offer',
    PURCHASE_OFFER_UPSELL = 'purchase_offer_upsell',

    CART_CONCIERGE = 'cart_concierge',
    CART_UPDATE = 'cart_update',
    CART_UPDATE_FOLLOWUP = 'cart_update_followup',
    CART_RECOMMENDATION = 'cart_recommendation',

    CHECKOUT_ONBOARD = 'checkout_onboard',
    CHECKOUT_PENDING = 'checkout_await_approve',
    CHECKOUT_CHANGE = 'checkout_change',
    CHECKOUT_CANCELED = 'checkout_canceled',
    CHECKOUT_PROCESSING = 'checkout_processing',
    CHECKOUT_COMPLETE = 'checkout_complete',
    CHECKOUT_ERROR = 'checkout_error',
    CHECKOUT_FEEDBACK = 'checkout_feedback',
    CHECKOUT_PAYMENT = 'checkout_payment',
    CHECKOUT_SCHEDULE_REQUEST = 'checkout_schedule_request',
    CHECKOUT_SCHEDULED = 'checkout_scheduled',
    CHECKOUT_WELCOME = 'checkout_welcome',
    CHECKOUT_CONFIRM = 'checkout_recent_confirm',

    EXTERNAL_ORDER_CONFIRM = 'external_order_confirm',

    PRODUCT_SEARCH_FOLLOWUP_QUESTION = 'product_search_followup_question',

    SUBCRIPTION_REFILL_PENDING = 'subscription_refill_pending',
    SUBSCRIPTION_SKIP = 'subscription_skip',
    SUBSCRIPTION_CHANGE = 'subscription_change',
    SUBSCRIPTION_CANCEL = 'subscription_cancel',
    SUBSCRIPTION_OFFER = 'subscription_offer',
    SUBSCRIPTION_OFFER_ACCEPT = 'subscription_offer_accept',
    SUBSCRIPTION_OFFER_REFUSE = 'subscription_offer_refuse',
    SUBSCRIPTION_CREATED = 'subscription_created',
    SUBSCRIPTION_REFILL_RETRY = 'subscription_refill_retry',
    SUBSCRIPTION_REFILL_FAILED = 'subscription_refill_failed',

    MARKETING = 'marketing',

    SATOSHI_SEND_SUCCESS = 'satoshi_send_success',
    SATOSHI_SEND_FAILED = 'satoshi_send_failed',

    SATOSHI_WITHDRAW_AWAIT_INVOICE = 'satoshi_withdraw_await_invoice',
    SATOSHI_WITHDRAW_SUCCESS = 'satoshi_withdraw_success',
    SATOSHI_WITHDRAW_FAILED = 'satoshi_withdraw_failed',

    SWITCH_TO_ONETEXT_THREAD = 'switch_to_onetext_thread',

    SUPPORT_THREAD_RESPONSE = 'support_thread_response',

    NO_STOCK_PREORDER = 'no_stock_preorder',
    NO_STOCK_PREORDER_CANCEL = 'no_stock_preorder_cancel',

    COLLECT_USER_INFO = 'collect_user_info',

    SMS_OPT_OUT = 'sms_opt_out',
    SMS_OPT_IN = 'sms_opt_in',

    FLOW = 'flow',

    SUPPORT_REQUEST = 'support_request',
    CHANGE_ORDER_QUESTION = 'change_order_question',
    ORDER_SHIPPED = 'order_shipped',

    PRODUCT_VARIANT_CHOICE = 'product_variant_choice',
    PRODUCT_CHOICE_FOLLOWUP = 'product_choice_followup',
    VARIANT_CHOICE_AI_MESSAGE = 'variant_choice_ai_message',

    EXTERNAL_ORDER_COMPLETE = 'external_order_complete',

    RECOMMENDATION_AGENT_FOLLOWUP = 'recommendation_agent_followup',

    RESPONSE = 'response'
}

export enum SHORT_LINK_ACTION {
    REDIRECT = 'redirect',
    QRCODE = 'qrcode',
    BUTTON = 'button',
    CONFIRM = 'confirm',
    NOT_FOUND_DEFAULT = 'not_found_default',
    REDIRECT_PREVENT_APP_SWITCH = 'redirect_prevent_app_switch'
}

export enum STATIC_SHORT_LINK_TYPE {
    ONE_OFF = 'one_off',
    ONBOARD = 'onboard',
    ONBOARD_CHECKOUT = 'onboard_checkout',
    EXTERNAL_ORDER_STATUS = 'partner_order_status',
    EXTERNAL_ORDER_RECOVERY = 'external_order_recovery',
    SWITCH_TO_THREAD = 'switch_to_onetext_thread',
    CONTACT_CARD = 'contact_card',
    MERCHANT_DASHBOARD = 'merchant_dashboard',
    MERCHANT_STORE_URL = 'merchant_store_url',
    PAYPAL_CONNECT = 'paypal_connect',
    STRIPE_CONNECT = 'stripe_connect',
    SHOPIFY_APP_INSTALL = 'shopify_app_install',
    WOO_CONNECT = 'woo_connect',
    AUTH = 'auth'
}

export enum DYNAMIC_SHORT_LINK_TYPE {
    SEND_INCOMING_MESSAGE = 'send_incoming_message',
    SEND_INCOMING_CUSTOM_FLOW_START_MESSAGE = 'send_incoming_flow_start_message',
    SEND_INCOMING_CORE_FLOW_START_MESSAGE = 'send_incoming_core_flow_start_message',
    SEND_INCOMING_MARKETING_SHORTTOKEN_MESSAGE = 'incoming_message',
    PURCHASE = 'purchase'
}

export type SHORT_LINK_TYPE = STATIC_SHORT_LINK_TYPE | DYNAMIC_SHORT_LINK_TYPE;

export enum SHORT_TOKEN_TYPE {
    START_CUSTOM_FLOW = 'flow',
    START_CORE_FLOW = 'start_core_flow'
}

export enum INBOUND_KEYWORD_TYPE {
    START_CUSTOM_FLOW = 'flow',
    START_CORE_FLOW = 'start_core_flow'
}

export enum MESSAGE_PROVIDER {
    TWILIO = 'twilio',
    TELNYX = 'telnyx',
    INFOBIP = 'infobip',
    MOCK = 'mock'
}

export enum MESSAGE_KEYWORD {
    PING = 'ping',
    PONG = 'pong',
    BETA = '#beta',
    OPT_IN = '#optin'
}

export enum UTM_QUERY_PARAM {
    SOURCE = 'utm_source',
    MEDIUM = 'utm_medium',
    CAMPAIGN = 'utm_campaign',
    TERM = 'utm_term',
    CONTENT = 'utm_content'
}

export enum MESSAGE_CHANNEL {
    SMS_MMS = 'sms_mms',
    RCS = 'rcs',
    WHATSAPP = 'whatsapp'
}

export enum WHATSAPP_CONVERSATION_TYPE {
    SERVICE = 'service',
    MARKETING = 'marketing',
    UTILITY = 'utility',
    CLICK_TO_WHATSAPP = 'click_to_whatsapp'
}

export enum PRODUCT_VIEW_RECOVERY_PREVIEW_TYPE {
    PURCHASE_OFFER = 'purchase_offer',
    PRODUCT_VARIANT_CHOICE = 'product_variant_choice'
}

export enum UNHANDLED_INTENT {
    OTHER = 'other',
    PURCHASE = 'purchase'
}
